import { HttpClient } from '@angular/common/http';
import { IToken } from '../dtos/responses/token.response';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CollectionApiClient } from '../../../../core/data-access/http-client/clients/api-client-service';
import { IIdentityAbiClient } from './identity-api-client.interface';
import { UserManagementCollections } from '../../../common/collections/user-management.collections';
import { IForgotPasswordRequest } from '../dtos/requests/forgot-password.request';
import { ILoginRequest } from '../dtos/requests/login.request';
import { IRefreshTokenRequest } from '../dtos/requests/refresh.request';
import { IResendConfirmationEmailRequest } from '../dtos/requests/resend-confirmation-email.request';
import { IResetPasswordRequest } from '../dtos/requests/reset-password.request';
import { IChangePasswordRequest } from '../dtos/requests/change-password.request';
import { IChangePhoneNumberRequest, IconfirmChangeEmailRequest, IConfirmChangePhoneNumberRequest } from '../dtos';
import { IChangeEmailRequest } from '../dtos/requests/change-email.request';

@Injectable({
  providedIn: 'root'
})
export class IdentityApiClient implements IIdentityAbiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(UserManagementCollections.Identity, http);
  }

  login(body: ILoginRequest): Observable<IToken> {
    return this.collectionApiClient.post({ body, collectionSegment: 'login' });
  }

  register(body: any): Observable<IToken> {
    return this.collectionApiClient.post({ body, collectionSegment: 'confirmRegistration' });
  }

  refresh(body: IRefreshTokenRequest): Observable<IToken> {
    return this.collectionApiClient.post({ body, collectionSegment: 'refresh' });
  }

  resendConfirmationEmail(body: IResendConfirmationEmailRequest): Observable<IToken> {
    return this.collectionApiClient.post({ body, collectionSegment: 'resendConfirmationEmail' });
  }

  forgotPassword(body: IForgotPasswordRequest): Observable<IToken> {
    return this.collectionApiClient.post({ body, collectionSegment: 'forgotPassword' });
  }

  resetPassword(body: IResetPasswordRequest): Observable<IToken> {
    return this.collectionApiClient.post({ body, collectionSegment: 'resetPassword' });
  }

  changePassword(body: IChangePasswordRequest): Observable<IToken> {
    return this.collectionApiClient.post({ body, collectionSegment: 'change-password' });
  }

  changePhoneNumber(body: IChangePhoneNumberRequest): Observable<void> {
    // return this.collectionApiClient.post({ body, collectionSegment: 'change-phonenumber' });
    return this.collectionApiClient.post({
      body,
      collectionName: `${UserManagementCollections.Users}/me/change-phonenumber`
    });
  }

  confirmChangePhoneNumber(body: IConfirmChangePhoneNumberRequest): Observable<void> {
    return this.collectionApiClient.post({
      body,
      collectionName: `${UserManagementCollections.Users}/me/confirm-change-phonenumber`
    });
  }

  changeEmail(body: IChangeEmailRequest): Observable<void> {
    return this.collectionApiClient.post({
      body,
      collectionName: `${UserManagementCollections.Users}/me/change-email`
    });
  }

  confirmChangeEmail(body: IconfirmChangeEmailRequest): Observable<void> {
    return this.collectionApiClient.post({
      body,
      collectionName: `${UserManagementCollections.Users}/me/confirm-change-email`
    });
  }

  deactivate(): Observable<void> {
    return this.collectionApiClient.put({
      collectionName: `${UserManagementCollections.Users}/me/deactivate`
    });
  }
}
